<!-- <Loader :loading="loading || isSubmitting" v-if="loading || isSubmitting"/> -->

<HomeNavBar />
<InactivityModal />
<div >
  <!-- Filters & Search -->
    <!-- Event List -->
 <div class="row justify-content-center">
  <div class="col-12 col-md-11 col-lg-9 h-100 overflow-auto mt-2">
    <div class="portal-tabs-card portal-tabs-strip bg-banner-gradient rounded">
      <div class="tabs-wrapper d-flex align-items-center px-2 py-1">
        <div class="scrollable-tabs flex-grow-1" ref="tabsContainer">
          <ul class="nav nav-tabs nav-justified w-100 border-0 text-xxs px-2 gap-0 portal-icon-tabs" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center active" id="upcoming-tab" data-bs-toggle="tab" data-bs-target="#upcoming" type="button"
                role="tab" aria-controls="upcoming" aria-selected="true">
                <i class="bi bi-calendar-event-fill"></i>
                <span>Upcoming Events</span>
              </button>
            </li>
            <li class="nav-item" role="presentation" v-if="token_exists">
              <button class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center" id="my_events-tab" data-bs-toggle="tab" data-bs-target="#my_events" type="button"
                role="tab" aria-controls="my_events" aria-selected="false">
                <i class="bi bi-calendar2-check-fill"></i>
                <span>My Events</span>
              </button>
            </li>
            <li class="nav-item" role="presentation" v-if="token_exists">
              <button class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center" id="past-tab" data-bs-toggle="tab" data-bs-target="#past" type="button"
                role="tab" aria-controls="past" aria-selected="false">
                <i class="bi bi-calendar2-x-fill"></i>
                <span>Past Events</span>
              </button>
            </li>
            <li class="nav-item" role="presentation" v-if="token_exists">
              <button
                class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
                id="my_tickets_tab"
                data-bs-toggle="tab"
                data-bs-target="#my_tickets"
                type="button"
                role="tab"
                aria-controls="my_tickets"
                aria-selected="false"
                @click.prevent="fetchUserTickets">
                <i class="bi bi-ticket-perforated-fill"></i>
                <span>My Tickets</span>
              </button>
            </li>
            <li class="nav-item d-none" role="presentation" v-if="user_details.user_role =='admin'">
              <button class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center" id="all_tickets_tab"
                      data-bs-toggle="tab" data-bs-target="#all_tickets"
                      type="button" role="tab" aria-controls="all_tickets" aria-selected="false" @click.prevent="get_event_tickets">
                <i class="bi bi-ticket-detailed-fill"></i>
                <span>All Tickets</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Filters Offcanvas (ref: Marketplace filter offcanvas) -->
    <div
      class="offcanvas offcanvas-end mt-4"
      tabindex="-1"
      id="filtersOffcanvas"
      aria-labelledby="filtersOffcanvasLabel"
    >
      <div
        class="offcanvas-header mt-5 d-flex align-items-center justify-content-start gap-3"
      >
        <button
          type="button"
          class="btn btn-sm text-primary p-0 border-0 bg-transparent shadow-none"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          <i class="fas fa-times fs-4"></i>
        </button>
        <h5 class="offcanvas-title mb-0 text-xs" id="filtersOffcanvasLabel">
          Filter Events
        </h5>
      </div>
      <div class="offcanvas-body">
        <!-- Search -->
        <div class="input-group rounded bg-light shadow-sm search-box w-100 mb-3">
          <span class="input-group-text bg-light border-0">
            <i class="bi bi-search text-muted"></i>
          </span>
          <input
            v-model="active_event_filters_draft.search"
            type="text"
            class="form-control bg-light border-0 shadow-none pe-2 text-xxs"
            placeholder="Search events..."
            @keyup.enter="apply_event_filters"
          />
        </div>

        <!-- Date range: Start -> End -->
        <div class="mb-3">
          <label class="form-label fw-semibold text-xxs">Date Range</label>
          <div class="row g-2">
            <div class="col-6">
              <input
                v-model="active_event_filters_draft.start_from"
                type="date"
                class="form-control rounded"
                placeholder="Start"
              />
            </div>
            <div class="col-6">
              <input
                v-model="active_event_filters_draft.end_to"
                type="date"
                class="form-control rounded"
                placeholder="End"
              />
            </div>
          </div>
        </div>

        <!-- Price Range -->
        <div class="mb-3">
          <label class="form-label fw-semibold text-xxs">Price Range</label>
          <div class="row g-2">
            <div class="col-6">
              <div class="input-group">
                <span class="input-group-text bg-light text-xxs">R</span>
                <input
                  v-model="active_event_filters_draft.min_price"
                  type="number"
                  class="form-control text-xxs"
                  placeholder="Min"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="input-group">
                <span class="input-group-text bg-light text-xxs">R</span>
                <input
                  v-model="active_event_filters_draft.max_price"
                  type="number"
                  class="form-control text-xxs"
                  placeholder="Max"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="d-grid gap-2">
          <button class="btn btn-primary rounded text-xxs" @click="apply_event_filters">
            Apply Filters
          </button>
          <button
            class="btn btn-outline-secondary rounded text-xxs"
            @click="clear_event_filters"
          >
            Clear Filters
          </button>
        </div>
      </div>
    </div>

    <div class="tab-content">
      <!--My Events tab-->
      <div class="tab-pane fade mb-5" id="my_events" role="tabpanel" aria-labelledby="my_events-tab">
        <div class="p-2 scrollable-container mb-5 no-scroll-chaining " ref="my_events_scroll_container" @scroll="handle_my_events_scroll">
            <div class="d-flex align-items-center mb-2">
              <CreateEvent :active_tab="active_tab" />
            </div>
            <div v-if="is_my_events_loading" class="text-center py-5 text-primary">
              <div class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></div>
              Loading your events...
            </div>

            <div
              v-else-if="filtered_my_events.length === 0"
              class="text-center py-5"
            >
              <i class="bx bx-calendar display-1 text-muted mb-3"></i>
              <div class="text-muted fs-5">
                {{ event_filters_active_for('my_events') ? 'No events match your filters' : 'No events found' }}
              </div>
            </div>

            <div v-else class="row g-3">
              <div
                class="col-12 col-sm-6 col-lg-4"
                v-for="event in filtered_my_events"
                :key="event.id"
              >
                <div
                  class="marketplace-product-card h-100 d-flex flex-column"
                  role="button"
                  tabindex="0"
                >
                  <div class="position-relative marketplace-card-media">
                    <div class="ratio rounded ratio-2x1 event-card-cover-frame">
                        <img
                         class="event-card-cover-image"
                          :style="{ objectFit: get_event_card_image_fit(event.id) }"
                          :src="get_event_cover_profile(event) || require('@/assets/images/event_image_placeholder.jpg')"
                          alt="Event Image"
                          loading="lazy"
                          @load="register_event_card_image_fit(event.id, $event)"
                        >
                    </div>
                    <div class="position-absolute top-0 start-0 m-2 d-flex gap-2 flex-wrap">
                      <span
                        v-if="my_event_state(event) === 'draft'"
                        class="marketplace-card-pill my-events-pill my-events-pill--draft"
                      >
                        Draft
                      </span>
                      <span
                        v-else
                        class="marketplace-card-pill my-events-pill my-events-pill--published"
                      >
                        Published
                      </span>
                    </div>
                  </div>

                  <div class="card-body p-3 d-flex flex-column text-start marketplace-card-body flex-grow-1">
                    <div class="flex-grow-1">
                      <p class="marketplace-card-name mb-1">
                        {{ event?.event_name}}
                      </p>
                      <div class="text-xs text-muted mb-0 mt-1" >{{formatDate(event.start_date) }}</div>
                      <div class="text-xs text-muted mb-0">{{ get_location_text(event) }}</div>
                    </div>

                    <div class="d-flex justify-content-between align-items-end gap-2 mt-3 marketplace-card-footer">
                      <button
                        type="button"
                        class="btn btn-sm btn-primary text-xxs rounded px-3 py-1 ms-auto"
                        @click.stop="go_to_manage_event(event)"
                      >
                        Manage Event
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="is_my_events_loading_more"
              class="d-flex justify-content-center align-items-center mt-3 py-2 text-muted"
            >
              <span class="spinner-border spinner-border-sm text-primary me-2" role="status" aria-hidden="true"></span>
              Loading more...
            </div>
        </div>
      </div>
      <!-- Upcoming Events -->
      <div class="tab-pane fade show active" id="upcoming" role="tabpanel" aria-labelledby="upcoming-tab">
        <div class="p-2 scrollable-container mb-5 no-scroll-chaining" ref="scrollContainer" @scroll="handleScroll">
          <div class="d-flex align-items-center mb-2">
            <CreateEvent :active_tab="active_tab" />

            <div class="ms-auto">
              <button
                class="btn btn-sm"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#filtersOffcanvas"
                aria-controls="filtersOffcanvas"
              >
                Filter Events
                <i class="bi bi-funnel-fill ms-2"></i>
              </button>
            </div>
          </div>
          <!-- Copy of upcoming_events card loop here -->
          <div v-if="!is_event_loading && filtered_upcoming_events.length === 0" class="text-center py-5">
            <i class="bx bx-calendar display-1 text-muted mb-3"></i>
            <p class="text-muted fs-5">
              {{ event_filters_active_for('upcoming') ? "No events match your filters" : "You don't have any upcoming events" }}
            </p>
          </div>
          <div v-else>
            <!-- Upcoming Events cards (new UI) -->
            <div class="row g-3">
              <div class="col-12 col-sm-6 col-lg-4" v-for="event in filtered_upcoming_events" :key="event.id">
                <div
                  class="marketplace-product-card ws-share-popover-host cursor-pointer h-100"
                  role="button"
                  tabindex="0">
                  <div class="position-relative marketplace-card-media">
                    <div class="ratio rounded ratio-2x1 event-card-cover-frame">
                      <img class="event-card-cover-image"
                          :style="{ objectFit: get_event_card_image_fit(event.id) }"
                          :src="get_event_cover_profile(event) || require('@/assets/images/event_image_placeholder.jpg')"
                          alt="Event cover"
                          loading="lazy"
                          @load="register_event_card_image_fit(event.id, $event)"/>
                    </div>
                    <span
                      v-if="event?.promo_codes?.length && event?.promo_codes?.length > 0 && isPromoValid(event?.promo_codes[0]?.valid_start_date, event?.promo_codes[0]?.valid_end_date)"
                      class="position-absolute top-0 start-0 mt-4 ms-2 px-2 py-1 rounded-pill lh-1 fw-semibold text-white bg-secondary text-xs"  @click.stop="open_promo_code_modal(event)"
                    >
                      Promo
                    </span>
                    <span
                      class="position-absolute top-0 end-0 mt-4 me-2 task-chip"
                      :class="get_event_timing_badge(event) === 'Ongoing'
                        ? 'task-chip-status'
                        : get_event_timing_badge(event) === 'Ended'
                          ? 'task-due-chip-overdue'
                          : 'task-chip-priority'"
                    >
                      {{ get_event_timing_badge(event) }}
                    </span>
                  </div>

                    <div class="card-body p-3 d-flex flex-column text-start marketplace-card-body flex-grow-1">
                      <div class="d-flex justify-content-between align-items-start gap-2">
                        <div class="d-flex align-items-center gap-2 flex-wrap">
                          <div class="marketplace-card-name mb-1 ">
                            {{ event.event_name }}
                          </div>
                        </div>
                        <div
                          class="dropend mt-1"
                          @click.stop
                          v-if="token_exists && String(event?.user?.id) === String(get_user_id()) || token_exists && user_details.user_role === 'admin'">
                          <a
                            href=""
                            class="fw-bold text-dark"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i class="bi bi-three-dots-vertical"></i>
                          </a>

                          <ul class="dropdown-menu custom-dropdown lh-1" aria-labelledby="dropdownMenuButton">
                            <li>
                              <a
                                class="dropdown-item text-xxs fw-bold"
                                href=""
                                @click.prevent="edit_event(event)"
                              >
                                <i class='bx bxs-edit fs-6'></i> Edit
                              </a>
                            </li>

                            <li>
                              <a
                                class="dropdown-item text-xxs fw-bold"
                                href=""
                                @click.prevent="deleteEvent(event.id)"
                              >
                                <i class='bx bxs-trash-alt fs-6'></i> Delete
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="text-xs text-muted mb-0">
                        {{event?.location}}
                      </div>
                      <div class="text-xs text-muted mb-0">
                        {{ formatDate(event.start_date) }}
                      </div>
                      <div class="mt-1 d-flex justify-content-between align-items-center">
                        <div v-if="(String(event?.user?.id) !== String(get_user_id()))">
                          <button
                            v-if="!event.is_free"
                            type="button"
                            class="btn btn-sm btn-primary text-xxs rounded px-3 py-1"
                            @click.stop="openModal(event)">
                            Buy Tickets
                          </button>

                          <div v-else class="d-inline">
                            <button
                              v-if="event.is_rsvped"
                              type="button"
                              class="btn btn-sm btn-danger text-xxs rounded px-3 py-1"
                              @click.stop="cancelRSVP(event.id)">
                              Cancel RSVP
                            </button>
                            <button
                              v-else-if="rsvp_button(event)"
                              type="button"
                              class="btn btn-sm btn-primary text-xxs rounded px-3 py-1"
                              @click.stop="openModal(event)">
                              RSVP
                            </button>
                            <button
                              v-else-if="event.is_waitlisted"
                              class="btn btn-sm btn-primary text-white text-xxs rounded px-3 py-1 shadow"
                              disabled>
                              On Waiting List
                            </button>

                            <button
                              v-else-if="event.is_free"
                              class="btn btn-sm btn-primary text-xxs rounded px-3 py-1 shadow"
                              @click.stop="openModal(event)">
                              Join Waiting List
                            </button>
                          </div>
                        </div>

                        <button
                          type="button"
                          class="btn btn-sm btn-primary text-xxs rounded px-3 py-1 ms-auto"
                          @click.stop="go_to_event(event)">
                          View Event
                        </button>
                      </div>
                    </div>
                    <div class="border-top pt-1 pb-2 px-3 d-flex align-items-start justify-content-between gap-2 mt-auto">
                      <div class="d-flex align-items-center flex-wrap gap-2">
                        <div class="position-relative">
                          <button
                            type="button"
                            class="info-tag marketplace-card-icon-btn"
                            @click.stop="toggle_share_menu(event.id)"
                          >
                            <i class="bi bi-share"></i>
                          </button>

                          <div
                            v-if="is_share_menu_open(event.id)"
                            class="incident-share-popover ws-share-popover shadow-sm"
                            @click.stop
                          >
                            <button
                              type="button"
                              class="incident-share-item"
                              @click.stop="copy_event_link(event)"
                            >
                              <i class="bi bi-link-45deg text-primary"></i>
                              <span>Copy link</span>
                            </button>
                            <a
                              class="incident-share-item"
                              target="_blank"
                              rel="noopener noreferrer"
                              :href="share_link_facebook(event)"
                              @click="close_share_menu(event.id)"
                            >
                              <i class="bi bi-facebook text-primary"></i>
                              <span>Facebook</span>
                            </a>
                            <a
                              class="incident-share-item"
                              target="_blank"
                              rel="noopener noreferrer"
                              :href="share_link_whatsapp(event)"
                              @click="close_share_menu(event.id)"
                            >
                              <i class="bi bi-whatsapp text-success"></i>
                              <span>WhatsApp</span>
                            </a>
                            <a
                              class="incident-share-item"
                              target="_blank"
                              rel="noopener noreferrer"
                              :href="share_link_email(event)"
                              @click="close_share_menu(event.id)"
                            >
                              <i class="bi bi-envelope text-secondary"></i>
                              <span>Email</span>
                            </a>
                          </div>
                        </div>

                        <button
                          v-if="validate_user(event)"
                          type="button"
                          class="info-tag marketplace-card-icon-btn"
                          aria-label="Scan ticket"
                          @click.stop="startScanning(event.id)"
                        >
                          <i class="bi bi-qr-code-scan"></i>
                        </button>
                      </div>
                    <div>
                    <div v-if="upcoming_price_info(event).label" class="text-muted text-xs">
                      {{ upcoming_price_info(event).label }}
                    </div>
                    <div class="text-xs fw-bold text-danger">
                      {{ upcoming_price_info(event).value }}
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>

            <div 
              v-if="!is_event_loading && has_more" 
              class="d-flex justify-content-center align-items-center mt-3 py-2 text-muted" 
            > 
              <span class="spinner-border spinner-border-sm text-primary me-2" role="status" aria-hidden="true"></span>
              Loading more...
            </div>



            <!-- Legacy Upcoming UI (kept for reference, disabled) -->
             <div v-if="false" class="d-none">
           <div class="card p-4 shadow-sm rounded border-0 mb-3 cursor-pointer" v-for="event in filtered_upcoming_events" :key="event.id" @click="go_to_event(event)">
            <div class="justify-content-between align-items-start">
              <div>
                <h5 class="card-title mb-1 d-flex flex-wrap align-items-center w-100 justify-content-between">
                  <a href="#" class="d-block d-sm-none text-truncate text-primary fw-bolder">
                    {{ event.event_name }}
                  </a>
                  <a href="#" class="d-none d-sm-block text-primary fw-bolder">
                    {{ event.event_name }}
                  </a>
                  <div v-if="event?.promo_codes?.length && event?.promo_codes?.length > 0 &&  isPromoValid(event?.promo_codes[0]?.valid_start_date, event?.promo_codes[0]?.valid_end_date)"
                      class="position-relative d-inline-flex align-items-center justify-content-center text-xxxs promo-tag cursor-pointer"
                      @click.stop="open_promo_code_modal(event)">
                    <i class="bi bi-tag-fill text-primary"></i>
                    <span class="position-absolute text-xxxs text-white text-align-center h-1 centered-promo-tag">
                      PROMO CODE
                    </span>
                  </div>
                  <div class="d-flex justify-content-end align-items-center mt-2 gap-1">
                    <button
                      v-if="event.is_rsvped"
                      class="btn btn-sm btn-danger fw-500 text-xxs rounded"
                      @click="cancelRSVP(event.id)">
                      Cancel RSVP
                    </button>

                    <button
                      v-else-if="rsvp_button(event)"
                      class="btn btn-sm btn-primary text-xxs rounded px-3 py-1 shadow"
                      @click.stop="openModal(event)">
                      RSVP
                    </button>

                    <button
                      v-else-if="event.is_waitlisted"
                      class="btn btn-sm btn-primary text-white text-xxs rounded px-3 py-1 shadow"
                      disabled>
                      On Waiting List
                    </button>

                    <button
                      v-else-if="event.is_free"
                      class="btn btn-sm btn-primary text-xxs rounded px-3 py-1 shadow"
                      @click.stop="openModal(event)">
                      Join Waiting List
                    </button>
                  <button
                    v-if="!event.is_free"
                    class="btn btn-sm btn-primary text-xxs rounded px-3 py-1 shadow"
                    @click.stop="openModal(event)"
                  >
                    Buy Ticket
                  </button>


                    <!-- Scan Button (next to Buy Ticket / RSVP) -->
                    <button
                      v-if="validate_user(event)"
                      class="btn btn-sm btn-primary text-xxs rounded px-3 py-1 shadow"
                      @click.stop="startScanning(event.id)">
                      Scan Ticket
                    </button>
                   <div class="dropend float-end mt-1" @click.stop v-if="token_exists && String(event?.user?.id) === String(get_user_id()) || token_exists && user_details.user_role === 'admin'">
                      <a href="" class="fw-bold text-dark" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="bi bi-three-dots-vertical"></i>
                      </a>
                      <ul class="dropdown-menu custom-dropdown lh-1" aria-labelledby="dropdownMenuButton">
                        <li>
                          <a class="dropdown-item text-xxs fw-bold" href="" @click.prevent="edit_event(event)">
                            <i class='bx bxs-edit fs-6'></i> Edit
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item text-xxs fw-bold" href="" @click.prevent="deleteEvent(event.id)">
                            <i class='bx bxs-trash-alt fs-6'></i> Delete
                          </a>
                        </li>
                      </ul>
                    </div>
                 </div>
                </h5>

                <div v-if="!event.is_free && event.event_tickets.length" class="mt-3">
                <h6 class="fw-bold text-sm mb-2">Available Tickets:</h6>

                <ul class="list-unstyled mb-0">
                  <li
                    v-for="ticket in event.event_tickets"
                    :key="ticket.id"
                    class="row g-0 border-bottom py-1"
                  >
                    <span class="col-6 fw-medium text-xxs text-start">
                      {{ ticket?.ticket?.name }}
                    </span>

                    <span class="col-3 text-muted text-xxs text-start">
                      R {{ ticket?.price }}
                    </span>

                    <span class="col-3 fw-medium text-xxs text-end">
                      Quantity: {{ ticket?.available_instances }}
                    </span>
                  </li>
                </ul>
              </div>
                <small class="text-muted">{{formatDate(event.start_date)}}, {{ event.start_time ? form_time(event.start_time) : "" }} - {{formatDate(event.end_date)}},  {{ event.end_time ? form_time(event.end_time) : "" }}</small>
              </div>

            </div>
             <!-- Show the speakers -->
            <section id="speaker-section" v-if="event?.speakers?.length > 0">
              <div class="d-md-none">
                <div class="text-uppercase fw-bold text-muted mb-2 text-xxs" >
                  <i class="bi bi-mic me-1"></i> Speakers
                </div>
                <div class="d-flex align-items-center overflow-x-auto hide-scrollbar pb-1">
                  <div
                    v-for="(speaker, index) in event.speakers.slice(0, 3)"
                    :key="index"
                    class="rounded-circle border border-2 border-white d-flex align-items-center justify-content-center bg-banner-gradient text-white fw-semibold hover-lift me-n2 flex-shrink-0 ai-agent-icon text-xxs cursor-pointer"
                  >
                    <img
                      v-if="speaker.speaker_files && speaker.speaker_files.length > 0"
                      :src="speaker.speaker_files[0].file.file_url"
                      class="rounded-circle w-100 h-100 object-fit-cover"
                    />
                    <span v-else>
                      {{ speaker.first_name.charAt(0).toUpperCase() }}{{ speaker.last_name.charAt(0).toUpperCase() }}
                    </span>
                  </div>
                  <span
                    class="text-secondary fw-medium ms-3 text-nowrap hover-text-brand cursor-pointer text-xxs"
                  >
                    {{ event.speakers.length }} speaker{{ event.speakers.length !== 1 ? 's' : '' }}
                    <i class="bi bi-chevron-right text-xxs"></i>
                  </span>
                </div>
              </div>

              <div class="d-none d-md-block">
                <div class="text-uppercase fw-bold text-muted mb-2 text-xxs ms-1">
                  <i class="bi bi-mic me-1"></i> Speakers
                </div>
                <div class="d-flex flex-wrap gap-2 align-items-center">
                  <div
                    v-for="(speaker, index) in event.speakers.slice(0, 3)"
                    :key="index"
                    class=" d-inline-flex align-items-center bg-white border rounded-pill py-1"
                    @click="view_speakers(event)"
                  >
                    <div
                      class="rounded-circle border d-flex align-items-center justify-content-center fw-bold flex-shrink-0 ms-1 ai-agent-icon text-xxxs bg-banner-gradient text-white border-border-primary"
                    >
                      <img
                        v-if="speaker.speaker_files && speaker.speaker_files.length > 0"
                        :src="speaker.speaker_files[0].file.file_url"
                        class="rounded-circle w-100 h-100 object-fit-cover"
                      />
                      <span v-else>
                        {{ speaker.first_name.charAt(0).toUpperCase() }}{{ speaker.last_name.charAt(0).toUpperCase() }}
                      </span>
                    </div>
                    <div class="d-flex flex-column ms-2">
                      <span class="fw-semibold text-dark text-truncate lh-sm text-xxs modal-custom speaker-card-width">
                        {{ speaker.first_name }} {{ speaker.last_name }}
                      </span>
                    </div>
                  </div>

                  <div
                    v-if="event.speakers.length > 3"
                    class="d-inline-flex align-items-center bg-primary text-white rounded-pill px-2 py-1 border border-dark cursor-pointer"
                    @click="view_speakers(event)"
                  >
                    <div class="d-flex align-items-center">
                      <div
                        v-for="(sp, i) in event.speakers.slice(3, 6)"
                        :key="i"
                        class="ai-agent-icon text-xxs cursor-pointer bg-banner-gradient rounded-circle border border-dark d-flex align-items-center justify-content-center fw-bold me-n1 flex-shrink-0"
                      >
                        <img
                          v-if="sp.speaker_files && sp.speaker_files.length > 0"
                          :src="sp.speaker_files[0].file.file_url"
                          class="rounded-circle w-100 h-100 object-fit-cover"
                        />
                        <span v-else>{{ sp.first_name.charAt(0) }}</span>
                      </div>
                    </div>
                    <span class="fw-bold ms-2 text-xxxs">+{{ event.speakers.length - 3 }} more</span>
                  </div>
                </div>
              </div>
            </section>
            <p v-if="check_description(event.description)" class="mt-3 mb-4 text-xxs text-muted" v-html="event.description"></p>
            <div class="d-flex flex-wrap gap-2 mt-3">
              <span class="tag text-xxs d-inline-flex align-items-center">{{  daysUntil(event) }}</span>
              <span class="info-tag text-xxs"><i class="bi bi-geo-fill"></i> {{event.location}}</span>
              <span class="info-tag text-xxs"><i class="bi bi-person"></i> {{event.organizer}}</span>
              <span v-if="event.is_free && token_exists && String(event.user?.id) === String(get_user_id()) || event.is_free && token_exists && user_details.user_role === 'admin'" class="info-tag text-xxs" @click="selectEvent(event)" data-bs-toggle="modal" data-bs-target="#exampleModal">
                <i class="bi bi-people"></i> {{event.rsvp_count}} Attendees
              </span>
              <span v-if="!event.is_free && token_exists && String(event.user?.id) === String(get_user_id()) || !event.is_free && token_exists && user_details.user_role === 'admin'" class="info-tag text-xxs">
                <i class="bi bi-ticket-perforated"></i> View Attendees
              </span>
              </div>
            <div class="gap-2 mt-2" v-if="event.is_recurring">
                <span class="text-muted text-xxs ms-2">Recurring :{{ event.recurring_pattern?.name }}</span>
              </div>



          <teleport to="body">
            <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title me-auto" id="exampleModalLabel">Attendees for this event</h5>
                    <div class="d-flex align-items-center">
                    <button v-if="(user_details.user_role==='admin' ||String(event?.user?.id) === String(get_user_id())) && token_exists" class="btn btn-sm btn-primary text-xxs rounded px-3 py-1 ms-2 justify-content-end me-3" @click="exportToCSV(selectedEvent)">
                      Export RSVP
                    </button>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  </div>
                  <div class="modal-body table-responsive">
                    <table class="table table-striped text-xxs">
                      <thead class="text-uppercase btn-primary text-white sticky-top">
                        <tr>
                          <th class="fw-light">First Name</th>
                          <th class="fw-light">Last Name</th>
                          <th class="fw-light">Email</th>
                          <th class="fw-light">Phone Number</th>
                          <th v-if="cbo_domain" class="fw-light">Business Name</th>
                          <th v-if="cbo_domain" class="fw-light">First Time attending?</th>
                          <th v-if="cbo_domain" class="fw-light">Chapter</th>
                          <th class="fw-light">Meal</th>
                          <th class="fw-light">Status</th>
                          <th class="fw-light">Redeemed</th>
                          <th class="fw-light">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="user in selectedEvent.rsvp_list" :key="user.id">
                          <td>{{user.user?.first_name}}</td>
                          <td>{{user.user?.last_name}}</td>
                          <td>{{user.user?.email}}</td>
                          <td>{{user.user?.phone_number}}</td>
                          <td v-if="cbo_domain">{{user.business_name}}</td>
                          <td v-if="cbo_domain">{{user.is_first_time ? 'Yes' : 'No' }}</td>
                          <td v-if="cbo_domain">{{user.chapter}}</td>
                          <td>
                            <span v-for="extra in user.rsvp_items">{{extra.item.item_name}},</span>
                          </td>
                          <td>
                            {{user.rsvp_status.name}}
                          </td>
                           <td>
                            {{user.is_attended ? 'Yes' : 'No'}}
                          </td>
                          <td>
                            <button
                            v-if="user.rsvp_status.name !== 'cancelled'"
                              class="btn btn-sm rounded btn-danger fw-500 text-xxs"
                              @click="cancelRSVP(selectedEvent.id, user.user.id)">
                              Cancel RSVP
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </teleport>

          <teleport to="body">
            <div class="modal fade" id="event_user_ticket" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Attendees for this event</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body table-responsive">
                    <table class="table table-striped text-xxs">
                      <thead class="text-uppercase btn-primary text-white sticky-top">
                        <tr>
                          <th class="fw-light">First Name</th>
                          <th class="fw-light">Last Name</th>
                          <th class="fw-light">Email</th>
                          <th class="fw-light">Ticket Name</th>
                          <th class="fw-light">Ticket Code</th>
                          <th class="fw-light">Redeemed</th>
                          <th class="fw-light">Purchased At</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="user in event_ticket_attendees" :key="user.id">
                          <td>{{user?.first_name}}</td>
                          <td>{{user?.last_name}}</td>
                          <td>{{user?.email}}</td>
                          <td>{{ user.ticket_name }}</td>
                          <td>{{ user.unique_code }}</td>
                          <td>{{ user.is_redeemed ? 'Yes' : 'No' }}</td>
                          <td>{{ newFormatDate(user.order_date) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </teleport>
          </div>
          </div>
          </div>
        </div>
      </div>

      <!-- Past Events -->
      <div class="tab-pane fade" id="past" role="tabpanel" aria-labelledby="past-tab">
       <div class="p-2 scroll-container">
        <div v-if="!is_event_loading && filtered_past_events.length === 0" class="text-center py-5">
          <i class="bx bx-calendar display-1 text-muted mb-3"></i>
          <p class="text-muted fs-5">
            {{ event_filters_active_for('past') ? "No events match your filters" : "You don't have any past events" }}
          </p>
        </div>
 

          <div v-if="is_event_loading" class="text-center py-5 w-100">
            <div class="spinner-border text-secondary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2 mb-0 text-muted">Loading events...</p>
          </div>
           <div v-else>
             <div
              v-for="event in filtered_past_events"
              :key="event.id"
              class="card border shadow-sm mb-4"
              @click.stop
            >
              <div class="card-body p-4">
                <!-- Header Section -->
                <div class="d-flex justify-content-between align-items-start mb-4">
                  <div class="flex-grow-1 pe-3">
                    <div class="d-flex align-items-center gap-2 mb-1 flex-wrap">
                      <p class="text-xxs fw-bold mb-0">
                        <a href="#" class="text-decoration-none">{{ event.event_name }}</a>
                      </p>

                      <!-- Recurring badge -->
                      <span
                        v-if="event.is_recurring"
                        class="badge bg-secondary rounded text-xxs"
                      >
                        Recurring : {{ event.recurring_pattern?.name }}
                      </span>
                    </div>

                    <!-- Date/time line -->
                    <small class="text-muted text-xxs">
                      {{ formatDate(event.start_date) }},
                      {{ event.start_time ? form_time(event.start_time) : '' }}
                      - {{ formatDate(event.end_date) }},
                      {{ event.end_time ? form_time(event.end_time) : '' }}
                    </small>

                    <!-- Make Recurring UI (kept and hidden as in original) -->
                    <div
                      v-if="canMakeRecurring(event)"
                      class="d-flex align-items-center gap-2 mt-2 d-none"
                    >
                      <select
                        v-model="recurrenceSelections[event.id]"
                        class="form-select form-select-sm w-auto"
                      >
                        <option disabled value="">Select Recurrence</option>
                        <option
                          v-for="pattern in recurring_patterns"
                          :key="pattern.id"
                          :value="pattern.id"
                        >
                          {{ pattern.name }}
                        </option>
                      </select>
                      <button
                        class="btn btn-sm btn-outline-primary d-none"
                        :disabled="!recurrenceSelections[event.id]"
                        @click="makeRecurring(event)"
                      >
                        Make Recurring
                      </button>
                    </div>
                  </div>

                  <!-- Actions (same permissions/logic) -->
                  <div class="d-flex align-items-center gap-3">
                    <!-- Days until (kept as a chip-style badge) -->
                      <span class="badge bg-banner-gradient rounded border text-xxs">
                        {{  daysUntil(event) }}
                      </span>
                    <div class="dropdown"
                        v-if="token_exists && String(event?.user?.id) === String(get_user_id()) || token_exists && user_details.user_role === 'admin'"
                        @click.stop>
                      <button
                        class="btn btn-light btn-sm rounded-circle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i class="bi bi-three-dots-vertical"></i>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-end custom-dropdown lh-1" v-if="token_exists">
                        <a
                          class="dropdown-item text-xxs border-bottom fw-bold d-none"
                          href=""
                          @click.prevent="togglePinReport(event)"
                        >
                          <i :class="event.is_pinned ? 'bx bx-pin fs-6' : 'bx bxs-pin fs-6'"></i>
                          {{ event.is_pinned ? 'Unpin' : 'Pin' }}
                        </a>
                        <li>
                          <a
                            class="dropdown-item text-xxs fw-bold"
                            href=""
                            @click.prevent="deleteEvent(event.id)"
                          >
                            <i class="bi bi-trash me-2"></i>Delete
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <hr class="my-4">

                <!-- Info Grid (mirrors ticket card layout) -->
                <div class="row g-4 mb-4">
                  <!-- Event Period -->
                  <div class="col-12 col-md-4">
                    <div class="d-flex gap-3">
                      <div class="bg-light rounded p-2 d-flex align-items-center justify-content-center">
                        <i class="bi bi-calendar-event fs-5 text-secondary"></i>
                      </div>
                      <div class="flex-grow-1">
                        <div class="text-uppercase text-muted small fw-semibold mb-1">Event Period</div>
                        <div class="fw-semibold text-xxs">{{ formatDate(event.start_date) }}</div>
                        <div class="text-muted text-xxs">
                          {{ event.start_time ? form_time(event.start_time) : '' }}
                          <span v-if="event.end_time"> to {{ form_time(event.end_time) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Location -->
                  <div class="col-12 col-md-4">
                    <div class="d-flex gap-3">
                      <div class="bg-light rounded p-2 d-flex align-items-center justify-content-center">
                        <i class="bi bi-geo-alt fs-5 text-secondary"></i>
                      </div>
                      <div class="flex-grow-1">
                        <div class="text-uppercase text-muted text-xxs fw-semibold mb-1">Location</div>
                        <div class="fw-semibold text-xxs">{{ event.location || 'Not set' }}</div>
                      </div>
                    </div>
                  </div>

                  <!-- Organizer & Attendees -->
                  <div class="col-12 col-md-4">
                    <div class="d-flex gap-3">
                      <div class="bg-light rounded p-2 d-flex align-items-center justify-content-center">
                        <i class="bi bi-people fs-5 text-secondary"></i>
                      </div>
                      <div class="flex-grow-1">
                        <div class="text-uppercase text-muted text-xxs fw-semibold mb-1">Organizer</div>
                        <div class="fw-semibold text-xxs mb-1">{{ event.organizer }}</div>

                        <div class="text-xxs">
                          <span
                            v-if="token_exists && String(event.user?.id) === String(get_user_id()) || token_exists && user_details.user_role === 'admin'"
                            class="badge bg-banner-gradient border rounded text-xxs d-inline-flex align-items-center gap-1"
                            @click="selectEvent(event)"
                            data-bs-toggle="modal"
                            data-bs-target="#pastModal"
                          >
                            <i class="bi bi-people"></i> {{ event.rsvp_count }} Attendees
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Description -->
                <div class="mt-2">
                  <div class="text-uppercase text-muted small fw-semibold mb-2">Description</div>
                  <p class="mb-0 text-xxs text-muted" v-html="event.description"></p>
                </div>
              </div>

              <!-- Attendees Modal (unchanged ids/variables) -->
              <div
                class="modal fade"
                id="pastModal"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header bg-primary text-white position-relative">
                      <p class="modal-title text-xxs fw-500" id="exampleModalLabel">Attendees for this event</p>

                      <button
                        v-if="(user_details.user_role==='admin' || String(event?.user?.id) === String(get_user_id())) && token_exists"
                        class="btn btn-sm btn-secondary text-xxs ms-2 shadow"
                        @click="exportToCSV(selectedEvent)"
                      >
                        Export RSVP
                      </button>

                      <button
                        type="button"
                        class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
                        data-bs-dismiss="modal"
                        aria-label="Close">
                      </button>
                    </div>

                    <div class="modal-body table-responsive">
                      <table class="table table-striped text-xxs">
                        <thead class="text-uppercase btn-primary text-white sticky-top">
                          <tr class="text-xxs">
                            <th class="fw-light">First Name</th>
                            <th class="fw-light">Last Name</th>
                            <th class="fw-light">Email</th>
                            <th class="fw-light">Phone Number</th>
                            <th v-if="cbo_domain" class="fw-light">Business Name</th>
                            <th v-if="cbo_domain" class="fw-light">First Time attending?</th>
                            <th v-if="cbo_domain" class="fw-light">Chapter</th>
                            <th class="fw-light">Meal</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="user in selectedEvent.rsvp_list" :key="user.id">
                            <td>{{ user.user?.first_name }}</td>
                            <td>{{ user.user?.last_name }}</td>
                            <td>{{ user.user?.email }}</td>
                            <td>{{ user.user?.phone_number }}</td>
                            <td v-if="cbo_domain">{{ user.business_name }}</td>
                            <td v-if="cbo_domain">{{ user.is_first_time ? 'Yes' : 'No' }}</td>
                            <td v-if="cbo_domain">{{ user.chapter }}</td>
                            <td>
                              <span v-for="extra in user.rsvp_items" :key="extra.id">
                                {{ extra.item.item_name }}<span v-if="false">,</span>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="tab-pane fade" id="my_tickets" role="tabpanel" aria-labelledby="my_tickets_tab">
        <div class="p-2 scrollable-container">

          <!-- Loading -->
          <div v-if="isTicketsLoading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2 text-muted fw-light">Fetching your tickets...</p>
          </div>

          <!-- No tickets -->
          <div v-else-if="tickets.length === 0" class="text-center py-5">
            <i class="bi bi-ticket-perforated display-1 text-muted mb-3"></i>
            <p class="text-muted fs-5">You have no tickets yet.</p>
          </div>

          <!-- Tickets List -->
          <div v-else class="d-flex flex-column gap-4">

            <div v-for="ticket in tickets" :key="ticket.unique_id" class="card p-4 shadow-sm rounded border-0 mb-3">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <h5 class="mb-1 fw-bold">Event: {{ ticket.event }}</h5>
                  <small class="text-muted d-block">Ticket: {{ ticket.ticket_name }}</small>
                  <small class="text-muted d-block">Date Purchased: {{ newFormatDate(ticket.order_date, true) }}</small>
                  <small class="text-muted d-block">Location: {{ ticket.location || 'Not set' }}</small>
                </div>
                <div class="text-end">
                  <strong class="text-success fs-5">R{{ ticket.price }}</strong><br>
                </div>
              </div>

              <div class="d-flex gap-2 flex-wrap mt-3">
                <button class="btn btn-primary btn-sm rounded-pill" @click="openTicketModal(ticket)">
                  <i class="bi bi-qr-code-scan me-1"></i> View
                </button>

              </div>
            </div>
          </div>

      <!-- Modal for Ticket Instances -->



        </div>

    </div>

<div class="tab-pane fade" id="all_tickets" role="tabpanel" aria-labelledby="all_tickets_tab">
  <div class="p-2 scrollable-container">

    <!-- Loading -->
    <div v-if="isTicketsLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2 text-muted fw-light">Fetching tickets...</p>
    </div>

    <!-- Tickets List -->
    <div v-else>
      <div v-if="event_tickets.length > 0" class="d-flex flex-column gap-3 me-3">
        <div
          v-for="ticket in event_tickets"
          :key="ticket.id"
          class="card border shadow-sm mb-4"
        >
          <div class="card-body p-4">
            <!-- Header Section -->
            <div class="d-flex justify-content-between align-items-start mb-4">
              <div class="flex-grow-1 pe-3">
                <div class="d-flex align-items-center gap-2 mb-1 flex-wrap">
                  <p class="text-xxs fw-bold mb-0">{{ ticket.event_name }}</p>
                  <span class="badge bg-primary rounded text-xxs flex-wrap text-truncate">
                    {{ ticket.ticket.name }}
                  </span>
                </div>
              </div>
              <div class="d-flex align-items-center gap-3">
                <div class="text-end">
                  <div class="fw-bold mb-0 text-xxs">R{{ ticket.price }}</div>
                  <small class="text-muted text-xxs">{{ ticket.quantity }} ticket{{ ticket.quantity > 1 ? 's' : '' }}</small>
                </div>
                <div class="dropdown">
                  <button
                    class="btn btn-light btn-sm rounded-circle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="bi bi-three-dots-vertical"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <a
                        class="dropdown-item text-xxs fw-bold"
                        href="#"
                        @click.prevent="open_edit_ticket_modal(ticket)"
                      >
                        <i class="bi bi-pencil me-2"></i>Edit
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <hr class="my-4">

            <!-- Info Grid -->
            <div class="row g-4 mb-4">
              <!-- Event Period -->
              <div class="col-12 col-md-4">
                <div class="d-flex gap-3">
                  <div class="bg-light rounded p-2 d-flex align-items-center justify-content-center">
                    <i class="bi bi-calendar-event fs-5 text-secondary"></i>
                  </div>
                  <div class="flex-grow-1">
                    <div class="text-uppercase text-muted small fw-semibold mb-1">Event Period</div>
                    <div class="fw-semibold text-xxs">{{ newFormatDate(ticket.start_date) }}</div>
                    <div class="text-muted text-xxs">to {{ newFormatDate(ticket.end_date) }}</div>
                  </div>
                </div>
              </div>

              <!-- Location -->
              <div class="col-12 col-md-4">
                <div class="d-flex gap-3">
                  <div class="bg-light rounded p-2 d-flex align-items-center justify-content-center">
                    <i class="bi bi-geo-alt fs-5 text-secondary"></i>
                  </div>
                  <div class="flex-grow-1">
                    <div class="text-uppercase text-muted text-xxs fw-semibold mb-1">Location</div>
                    <div class="fw-semibold text-xxs">{{ ticket.location || 'Not set' }}</div>
                  </div>
                </div>
              </div>

              <!-- Availability -->
              <div class="col-12 col-md-4">
                <div class="d-flex gap-3">
                  <div class="bg-light rounded p-2 d-flex align-items-center justify-content-center">
                    <i class="bi bi-clock fs-5 text-secondary"></i>
                  </div>
                  <div class="flex-grow-1">
                    <div class="text-uppercase text-muted text-xxs fw-semibold mb-1 text-xxs">Availability</div>
                    <div class="fw-semibold text-xxs">
                      <span :class="ticket.is_sold_out ? 'text-danger' : 'text-success'">
                        {{ ticket.available_instances }}
                      </span>
                      of {{ ticket.quantity }} available
                      <span v-if="ticket.available_instances === 0" class="badge bg-danger ms-1">
                        Sold Out
                      </span>
                    </div>
                    <div v-if="ticket.available_instances > 0" class="progress mt-2">
                      <div 
                        class="progress-bar bg-success" 
                        role="progressbar" 
                        :style="{ width: ((ticket.available_instances / ticket.quantity) * 100) + '%' }"
                        :aria-valuenow="ticket.available_instances"
                        :aria-valuemin="0"
                        :aria-valuemax="ticket.quantity"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- No tickets -->
      <div v-else class="text-center py-5">
        <i class="bi bi-ticket-perforated display-1 text-muted mb-3"></i>
        <p class="text-muted fs-5">No tickets found.</p>
      </div>
    </div>
  </div>
</div>

    </div>
  </div>
</div>
<teleport to="body">
<div class="modal fade" id="edit_ticket_modal" tabindex="-1" aria-labelledby="editTicketModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white position-relative">
        <p class="modal-title text-xxs fw-500" id="editTicketModalLabel">Edit Ticket</p>
        <button
          type="button"
          class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>

      <!-- FORM -->
      <form @submit.prevent="update_event_ticket()">
        <div class="modal-body modal-body-scroll">

          <div class="row">
            <div class="col-md-6">
              <label for="ticket_name" class="form-label text-xxs fw-500">Ticket Name</label>
              <input type="text" id="ticket_name" class="form-control rounded text-xxs" v-model="edit_name" readonly>
            </div>
            <div class="col-md-6">
              <!-- Ticket Price -->
              <label for="ticket_price" class="form-label text-xxs fw-500">Price (R) <span class="text-danger">*</span></label>
              <input type="number" id="ticket_price" class="form-control rounded text-xxs" v-model="edit_price" :disabled="is_sold_out" step="0.01"min="0">
              <p v-if="errors.price" class="text-danger text-xxs">{{ errors.edit_price }}</p>
              <p v-if="ticket.is_sold_out" class="text-danger text-xxs mt-1">This ticket is sold out and price cannot be changed.</p>
            </div>
            <div class="col-md-6">
              <!-- Start Date -->
              <label for="ticket_start" class="form-label text-xxs fw-500">Start Date & Time <span class="text-danger">*</span></label>
              <input type="datetime-local" id="ticket_start" class="form-control rounded text-xxs" v-model="edit_start_date">
              <p v-if="errors.edit_start_date" class="text-danger text-xxs">{{ errors.edit_start_date }}</p>
            </div>
            <div class="col-md-6">
              <!-- End Date -->
              <label for="ticket_end" class="form-label text-xxs fw-500">End Date & Time <span class="text-danger">*</span></label>
              <input type="datetime-local" id="ticket_end" class="form-control rounded text-xxs" v-model="edit_end_date">
              <p v-if="errors.edit_end_date" class="text-danger text-xxs">{{ errors.edit_end_date }}</p>
            </div>
            <div class="col-md-6">
              <label for="ticket_quantity" class="form-label fw-500 text-xxs">Quantity <span class="text-danger">*</span></label>
              <input 
                type="number" 
                id="ticket_quantity" 
                class="form-control rounded text-xxs"
                v-model.number="edit_quantity"
                :disabled="is_sold_out"
              >
              <p v-if="errors.quantity" class="text-danger text-xxs">{{ errors.quantity }}</p>
              <p class="text-muted text-xxs mt-1">
                Minimum quantity is {{ edit_quantity }}.
              </p>
            </div>
          </div>
        </div>

        <!-- FOOTER -->
        <div class="modal-footer">
          <button type="submit" class="btn-primary btn-sm btn-info text-xxs text-white rounded shadow-sm">Update Ticket</button>
        </div>
      </form>
    </div>
  </div>
</div>
</teleport>

<!-- Global scan modal (single instance) -->
<teleport to="body">
  <div class="modal fade" id="scanModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary ">
          <h5 class="modal-title text-white">Scan Ticket</h5>
          <button type="button" class="btn-close bg-light" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body text-center p-3">
          <!-- VIDEO AREA -->
          <video
            id="scan_video"
            v-show="showCamera"
            autoplay
            playsinline
            class="w-100 rounded shadow-sm"
          ></video>
          <canvas id="scan_canvas" hidden></canvas>

          <!-- RESULT AREA -->
          <div
            v-if="scanResultBox"
            class="p-3 rounded text-center"
            :class="{'bg-success text-white': scanSuccess, 'bg-danger text-white': !scanSuccess}"
          >
            <h3 class="fw-bold mb-2">
              {{ scanSuccess ? '✔ Ticket Validated' : '✖ Ticket Error' }}
            </h3>

            <div class="d-flex justify-content-center">
              <p v-if="scanSuccess" class="mt-3 text-start">
                <strong>Ticket ID:</strong> {{ scanData.ticket_id }} <br>
                <strong>Event:</strong> {{ scanData.event }} <br>
                <strong>Ticket Type:</strong> {{ scanData.ticket_type }}
              </p>

              <p v-else>{{ scanErrorMessage }}</p>
            </div>

            <button class="btn btn-primary mt-3 rounded fw-bold shadow" @click="restartScan">
              Scan Again
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>
<teleport to="body">
  <!-- Event Details Modal -->
  <div class="modal fade" id="eventModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded border-0 shadow-sm">
      <div class="modal-header border-0">
        <button type="button" class="btn-close text-xxs fw-500" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body modal-body-scroll d-flex flex-column align-items-center text-center">

        <img src="@/assets/images/thank-you.png" class="w-150" alt="">
        <h6 class="text-center">Thank you for registering</h6>
        <p class="text-center">Please confirm your RSVP below</p>

        <!-- JOIN LINK FOR ONLINE EVENTS -->
        <div v-if="(selectedEvent.event_type?.name === 'online') && selectedEvent.event_link">
          <a v-if="isEventStarted(selectedEvent).canJoin"
             :class="['btn', 'btn-sm', 'fw-500', 'me-2', 'btn-primary']"
             :href="selectedEvent.event_link">
            Join Event
          </a>
          <p v-else class="text-muted text-sm mt-1">
            {{ isEventStarted(selectedEvent).message }}
          </p>
        </div>

        <!-- RSVP / CANCEL LOGIC -->
        <div v-if="selectedEvent.event_type?.name !== 'online' ">
          <span v-if="!isWithinRSVPPeriod(selectedEvent).isValid" class="d-inline-block">
            <p class="text-danger text-xxs">{{ isWithinRSVPPeriod(selectedEvent).message }}</p>
          </span>

          <button v-else class="gap-3" :class="[
                    'btn',
                    'btn-sm',
                    'fw-500',
                    'me-2',
                    selectedEvent.is_rsvped ? 'btn-warning' : 'btn-primary'
                  ]" @click="handle_rsvp(selectedEvent)">
            {{ selectedEvent.is_rsvped ? 'RSVP’d' : (selectedEvent.rsvp_cap?.rsvp_current_count < selectedEvent.rsvp_cap?.rsvp_max_capacity || selectedEvent?.rsvp_cap=== null)? 'Confirm RSVP' : 'Join Waiting List'}}
          </button>
        </div>

      </div>
    </div>
  </div>
</div>

 <div class="modal fade" id="rsvp_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content border-0 shadow rounded-3 bg-light">

           <div class="modal-header bg-primary d-flex align-items-center">
              <i class="bi bi-ticket-perforated-fill text-white fs-3 me-2"></i> <!-- me-2 adds right margin -->
              <h5 class="modal-title fw-bold mb-0 fs-3 text-white" id="exampleModalLabel">RSVP</h5>
              <button type="button" class="btn-close bg-light" data-bs-dismiss="modal" @click="addRsvp"></button>
          </div>


            <form @submit.prevent="addRsvp">
                <div class="modal-body overflow-auto modal-scroll" >

                    <!-- Business Name -->
                    <div v-if="cbo_domain" class="mb-3">
                        <label for="businessName" class="form-label fw-semibold small text-secondary">Provide business name</label>
                        <input type="text" v-model="businessName" placeholder="Business Name" class="form-control rounded">
                    </div>

                    <!-- First Time Attending -->
                    <div v-if="cbo_domain" class="mb-3">
                        <label for="firstTimeSelect" class="form-label fw-semibold small text-secondary">Is this your first time attending?</label>
                        <select v-model="isFirstTime" class="form-select rounded" id="firstTimeSelect">
                            <option disabled value="">Please select an option</option>
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                        </select>
                    </div>

                    <!-- Home Chapter -->
                    <div v-if="cbo_domain" class="mb-4">
                        <label for="chapterSelect" class="form-label fw-semibold small text-secondary">Home Chapter</label>
                        <select v-model="chapter" class="form-select rounded" id="chapterSelect">
                            <option disabled value="">Please select a chapter</option>
                            <option v-for="chapter in chapters" :key="chapter" :value="chapter">{{ chapter }}</option>
                        </select>
                    </div>

                    <!-- Divider before extras -->
                    <div v-if="eventExtras.length > 0" class="border-top mb-4 pt-4"></div>

                    <!-- Menu Selection -->
                                          <!-- Menu Selection -->
                    <div v-for="extra in eventExtras" :key="extra.id" class="mb-4">
                      <div class="d-flex align-items-center gap-2 mb-3">
                          <i class="bi bi-star text-secondary fs-6"></i> 
                          <label class="form-label text-uppercase fw-bold mb-0 small text-primary">{{ extra.extra.name }}</label>
                      </div>

                      <div class="d-flex flex-column gap-2">
                          <div v-for="item in extra.items" :key="item.id"
                              class="border rounded p-3 d-flex align-items-center gap-3 cursor-pointer transition-all"
                              :class="{
                                  'border-primary bg-light shadow-sm': selectedItemId.includes(item.id),
                                  'bg-white': !selectedItemId.includes(item.id)
                              }"
                              @click="toggleItem(item.id)">

                              <input class="form-check-input mt-0 me-3" 
                                  type="checkbox"
                                  :id="'item_' + item.id"
                                  :value="item.id"
                                  v-model="selectedItemId" 
                                  @click.stop="toggleItem(item.id)"> <div class="flex-grow-1 d-flex justify-content-between align-items-center">
                                  <div>
                                      <div class="fw-semibold">{{ item.item_name }}</div>
                                      <div class="text-muted small">{{ item.description }}</div>
                                  </div>
                                  <div v-if="!workbook_domain" class="fw-bold text-primary small">R{{ item.price }}</div>
                              </div>
                          </div>
                      </div>
                  </div>

                    <!-- Validation Message -->
                    <div v-if="formError" class="alert alert-danger mt-3 py-2 px-3 small">
                        <strong>⚠️</strong> Please select at least one item to RSVP.
                    </div>

                    <!-- Dietary Restrictions (hidden) -->
                    <div class="mb-3 d-none">
                        <label class="form-label fw-semibold small">Additional Restrictions</label>
                        <textarea class="form-control rounded" rows="2" placeholder="Please specify any allergies or restrictions" v-model="dietaryRestrictions"></textarea>
                    </div>
                </div>

                <div class="modal-footer border-top py-3 bg-light">
                    <button type="submit" class="btn btn-primary text-xxs rounded" :disabled="!selectedItemId.length">Submit</button>
                    
                </div>
            </form>

        </div>
    </div>
</div>


</teleport>


<teleport to="body">
  <!-- Create Event -->
  <div class="modal fade" id="event_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable mx-auto marketplace-modal-dialog">
      <div class="modal-content rounded-5 overflow-hidden border-0 shadow-lg marketplace-modal-surface">
        <div class="modal-header d-flex justify-content-start border-0 bg-black position-relative z-index-10">
          <button
            type="button"
            class="btn p-0 border-0 shadow-none d-flex align-items-center justify-content-center modal-close-btn ms-auto"
            data-bs-dismiss="modal"
            aria-label="Close">
            <i class="fas fa-times fs-6"></i>
          </button>
        </div>
        <form @submit.prevent="submitEvent()">
          <div class="modal-body modal-body-scroll">

            <div class="mb-3">
              <input type="text" class="form-control rounded text-xxs" id="event_name" placeholder="Enter event name"
                v-model="event_name">
              <p v-if="errors.event_name" class="text-danger text-xxs">{{ errors.event_name }}</p>
            </div>
            <div class="d-flex flex-row justify-content-between mx-1">
            </div>
            <label class="form-label text-xxs fw-500">Event Category</label>
            <div class="d-flex flex-row align-items-center gap-3">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio" id="free_event"
                  :value="true"
                  v-model="is_free"
                  :disabled="is_editing_event"
                  checked
                />
                <label class="form-check-label text-xxs" for="free_event">Free</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="paid_event"
                  :value="false" v-model="is_free"
                  :disabled="is_editing_event"

                />
                <label class="form-check-label text-xxs" for="paid_event">Paid</label>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label text-xxs fw-500">Event Type <span class="text-danger">*</span></label>
              <div class="d-flex flex-row align-items-center">
                <div v-for="(type, index) in event_types" :key="index" class="form-check me-3">
                  <input type="radio" class="form-check-input" :value="type" v-model="event_type" :id="`${type}_event`"
                    :name="`event_type`" />
                  <label :for="`${type}_event`" class="form-check-label text-capitalize">{{ type.name }}</label>
                </div>
              </div>
              <p v-if="errors.event_type" class="text-danger text-xxs">{{ errors.event_type }}</p>
            </div>
             <div v-if="event_type.name === 'online' || event_type.name === 'hybrid'" class="mb-4">
              <input id="event_link" type="url" class="form-control rounded text-xxs"
                placeholder="Enter event link (e.g., Zoom, Google Meet,Teams)" v-model="event_link" />
              <p v-if="errors.event_link" class="text-danger text-xxs">{{ errors.event_link }}</p>
            </div>
            <div v-if="event_type.name !== 'online'" :key="event_type.name" class="mb-4">
             <input ref="mapInput" id="mapSearchBox" type="text" class="form-control rounded text-xxs"
                placeholder="Search location..." v-model="location" />
              <p v-if="errors.location" class="text-danger text-xxs">{{ errors.location }}</p>
            </div>

          <div class="row">
            <div class="col-12 col-md-6 mb-3">
              <label for="start_date" class="form-label text-xxs fw-500">
                Event start date <span class="text-danger">*</span>
              </label>
              <input
                type="datetime-local"
                class="form-control rounded text-xxs input-dark"
                id="start_date"
                v-model="start_date"
                :min="min_datetime"
                :disabled="is_event_dates_locked"
              >
              <p v-if="errors.start_date" class="text-danger text-xxs mt-1 mb-0">
                {{ errors.start_date }}
              </p>
            </div>

            <div class="col-12 col-md-6 mb-3">
              <label for="end_date" class="form-label text-xxs fw-500">
                Event end date <span class="text-danger">*</span>
              </label>
              <input
                type="datetime-local"
                class="form-control rounded text-xxs input-dark"
                id="end_date"
                v-model="end_date"
                :min="min_datetime"
                :disabled="is_event_dates_locked"
              >
              <p v-if="errors.end_date" class="text-danger text-xxs mt-1 mb-0">
                {{ errors.end_date }}
              </p>
            </div>
          </div>
          </div>

          <div class="modal-footer border-0">
            <button type="submit" class="btn btn-primary text-xxs rounded cursor-pointer" :disabled="!is_valid_event">Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="modal fade" id="ticket_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xxs fw-500">{{ selectedEvent?.event_name }}</p>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>

      <!-- BODY -->
      <div class="modal-body">

        <!-- Event Info -->
        <div class="text-start mb-3">
          <p class="mb-1 text-xxs text-muted">
            <i class="bi bi-calendar-event"></i>
            {{ formatDate(selectedEvent?.start_date) }}
          </p>
          <p class="mb-1 text-xxs text-muted" v-if="selectedEvent?.location">
            <i class="bi bi-geo-alt"></i>
            {{ selectedEvent.location }}
          </p>
          <span class="badge bg-light text-xxs rounded text-dark border rounded-pill" v-if="!selectedEvent?.is_free">
            Paid Event
          </span>
        </div>

        <!-- Tickets Section -->
        <!-- Tickets Section -->
        <!-- No Tickets -->
        <p class="text-xxs">Select Tickets</p>
        <div v-if="event_tickets.length === 0" class="text-center py-4">
          <p class="text-muted text-xxs">No available tickets for this event.</p>
        </div>

        <!-- Tickets -->
        <div v-else>
          <div v-for="ticket in event_tickets" :key="ticket.id"
              class="d-flex justify-content-between align-items-center border-0 shadow-sm bg-light p-2 mb-2">

            <!-- Ticket Info -->
            <div class="text-start">
              <div class="fw-500">
                {{ ticket?.ticket?.name }}
                <span v-if="ticket.is_sold_out" class="badge bg-danger text-xxs rounded ms-2">Sold Out</span>
              </div>

              <div class="text-success fw-bold">
                R{{ ticket?.price }}
              </div>

              <small class="text-muted" v-if="ticket.available_instances > 0">
                Available: {{ ticket.available_instances- ticket.quantitySelected  }}
              </small>
            </div>

            <!-- Counter -->
            <div v-if="validate_ticket_date(ticket?.start_date)" class="d-inline-flex align-items-center border rounded px-2">
              <button class="btn btn-sm text-xxs rounded border-0 shadow-0 px-2"
                      @click="ticket.quantitySelected = Math.max(0, ticket.quantitySelected - 1)">
                –
              </button>
              <span class="px-3">{{ ticket?.quantitySelected }}</span>
              <button class="btn btn-sm text-xxs rounded border-0 shadow-0 px-2"
                      @click="ticket.quantitySelected = Math.min(ticket.available_instances, ticket.quantitySelected + 1)">
                +
              </button>
            </div>
            <div v-else>
              <span class="badge rounded-pill bg-primary px-3 py-2 fw-light text-uppercase shadow-sm">Coming Soon</span>
            </div>
            
          </div>
        </div>

        <div class="promo-section-modal">
          <!-- Your existing promo code HTML goes here (unchanged) -->
          <div>
            <div class="d-flex align-items-center mb-2">
              <label class="text-muted text-xs mb-0 me-1">Have a promo code?</label>
              <i class="bi bi-question-circle-fill text-muted cursor-pointer text-xxs"></i>
            </div>
 
            <div class="d-flex gap-2">
              <div class="flex-grow-1">
                <input
                  type="text"
                  v-model="promo_input"
                  class="form-control rounded text-xxs"
                  placeholder="Enter promo code"
                  :disabled="is_applying"
                />
              </div>
              <button
                class="btn btn-primary btn-sm text-xxs rounded px-4"
                type="button"
                :disabled="!promo_input || is_applying"
                @click="apply_promo"
              >
                <span v-if="is_applying" class="spinner-border spinner-border-sm me-1"></span>
                Apply code
              </button>
            </div>
 
            <transition name="fade">
              <p v-if="promo_message" :class="['text-xs mt-2 mb-0', promo_status === 'success' ? 'text-success' : 'text-danger']">
                {{ promo_message }}
              </p>
            </transition>
 
            <div class="mt-2 text-end">
              <div v-if="applied_promo" class="text-success text-xxs mb-1">
                <i class="bi bi-tag-fill"></i>
                Applied:
                {{ applied_promo?.promo_code.promo_code_type?.name === 'percentage' ? applied_promo?.promo_code.discount_amount + '%' : 'R' + applied_promo?.promo_code.discount_amount }} off
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <div class="modal-footer d-flex justify-content-between align-items-center border-0">
        <p class="fw-bold text-xxs mb-0">Total: R{{ calculate_total() }}</p>
        <button class="btn btn-primary btn-sm text-xxs rounded px-4" @click="process_to_checkout":disabled="!event_tickets || event_tickets.length === 0"> Proceed To Checkout</button>
      </div>

    </div>
  </div>
</div>

<div class="modal fade" id="event_ticket_modal" tabindex="-1" aria-labelledby="eventticketModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white position-relative">
        <p class="modal-title text-xxs fw-500" id="eventticketModalLabel">{{ ticket_id ? 'Edit Ticket' : 'Create Ticket' }}</p>
        <button
          type="button"
          class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>

      <form @submit.prevent="create_ticket()">
        <div class="modal-body modal-body-scroll">

          <!-- Ticket Name -->
          <div class="mb-3">
            <label for="ticket_name" class="form-label text-xxs fw-500">Ticket Name <span class="text-danger">*</span></label>
            <input type="text" id="ticket_name" class="form-control rounded text-xxs" placeholder="Enter ticket name" v-model="ticket.name">
            <p v-if="errors.name" class="text-danger text-xxs">{{ errors.name }}</p>
          </div>

        </div>

        <div class="modal-footer">
          <button type="submit" class="btn btn-primary text-xxs rounded">{{ ticket_id ? 'Update Ticket' : 'Save Ticket' }}</button>
        </div>
      </form>
    </div>
  </div>
</div>


<div class="modal fade" id="ticketModal" tabindex="-1" aria-labelledby="ticketModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content rounded-4 border-0 shadow-lg">

      <!-- HEADER -->
      <div class="modal-header border-0 pb-0">
        <div>
          <h5 class="modal-title fw-bold" id="ticketModalLabel">
            {{ selectedTicket?.event }}
          </h5>
          <small class="text-muted">Ticket: {{ selectedTicket?.ticket_name }}</small>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- BODY -->
      <div class="modal-body px-4">

        <!-- Ticket & Event Info -->
        <div class="mb-4 p-3 rounded-4 bg-light shadow-sm">
          <div class="row">
            <div class="col-md-6">
              <p class="mb-1 text-muted small">Date Purchased</p>
              <p class="fw-semibold">{{ newFormatDate(selectedTicket?.order_date) }}</p>
            </div>
            <div class="col-md-6">
              <p class="mb-1 text-muted small">Location</p>
              <p class="fw-semibold">{{ selectedTicket?.location || 'Not set' }}</p>
            </div>

            <div class="col-md-6 mt-2">
              <p class="mb-1 text-muted small">Event Starts</p>
              <p class="fw-semibold">{{ newFormatDate(selectedTicket?.start_date) }} </p>
            </div>
            <div class="col-md-6 mt-2">
              <p class="mb-1 text-muted small">Event Ends</p>
              <p class="fw-semibold">{{ newFormatDate(selectedTicket?.end_date) }} </p>
            </div>

            <div class="col-12 mt-3">
              <p class="mb-1 text-muted small">Price</p>
              <h5 class="fw-bold text-success">R{{ selectedTicket?.price }}</h5>
            </div>
          </div>
        </div>

        <!-- Instances / QR Codes -->
        <div v-if="selectedTicket" class="row g-3">
          <div  class="col-6 col-md-4">
            <div class="card p-3 text-center shadow-sm rounded-4">
              <small class="d-block mt-2 text-muted">Ticket ID: {{ selectedTicket.unique_code }}</small>
               <img :src="qr_code(selectedTicket.qr_code)" alt="QR Code">
            </div>
          </div>
        </div>

      </div>

      <!-- FOOTER -->
      <div class="modal-footer border-0 d-flex justify-content-between align-items-center pt-0">
        <small class="text-muted">
          Present this ticket at the event entrance.
        </small>

        <button
          v-if="selectedTicket && !selectedTicket?.is_redeemed"
          type="button"
          class="btn btn-danger btn-sm rounded-pill px-3"
          @click="cancel_ticket(selectedTicket)"
        >
          Cancel Ticket
        </button>
      </div>

    </div>
  </div>
</div>
</teleport>


</div>

<PromoCode
  ref="promoManagerRef"
  :upcoming_events="upcoming_events"
  :event_id="event_id"
  @promo-updated="update_parent_promos"
  @promo-deleted="handle_parent_promo_deletion"
/>
<EventMediaGallery
  ref="eventMediaGalleryRef"
  :event_id="event_id"
  @media-updated="update_parent_event_files"
  @media-deleted="handle_parent_file_deletion"
  @pin-changed="handle_pin_update"
/>

<teleport to="body">
<div class="modal fade" id="availablePromosModal" tabindex="-1" aria-labelledby="availablePromosModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content rounded shadow scrollable-container">
      <!-- Modal Header -->
      <div class="modal-header bg-primary position-relative">
        <div class="d-flex align-items-center gap-2">
          <h5 class="modal-title text-white" id="availablePromosModalLabel">
            Available Promo
          </h5>
        </div>
        <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body table-responsive">
        <!-- Subtitle -->
        <p class="text-muted mb-4 text-xxs">
          Select a promo code below to copy and use at checkout
        </p>

        <!-- Promos  -->
        <div class="d-flex flex-column gap-3">
          <div
            class="promo-item p-3 border rounded-2 cursor-pointer"
            @click.stop="selectPromo(selected_event_agenda?.promo_codes[0]?.promo_code_name)"
          >
            <div class="d-flex align-items-center justify-content-between gap-2">
              <div class="d-flex align-items-center gap-3 flex-grow-1">
                <div class="d-flex align-items-center justify-content-center flex-shrink-0 rounded-3 text-white bg-primary rounded icon-box">
                  <i class="bi bi-tag-fill"></i>
                </div>
                <div>
                  <div class="fw-bold text-dark text-xxss">{{ selected_event_agenda?.promo_codes[0]?.promo_code_name }}</div>
                   {{ selected_event_agenda?.promo_codes[0]?.promo_code.promo_code_type?.name === 'percentage' ? selected_event_agenda?.promo_codes[0]?.promo_code.discount_amount + '%' : 'R' + selected_event_agenda?.promo_codes[0]?.promo_code.discount_amount }} off
                </div>
              </div>
              <i class="bi bi-copy text-bg-primary flex-shrink-0"></i>
            </div>
          </div>
        </div>
         <div aria-live="polite" aria-atomic="true" class="position-fixed custom-toast">
        <div id="copyToast" class="toast align-items-center text-bg-success border-0" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="d-flex">
              <div class="toast-body">
                Link copied to clipboard!
              </div>
              <button type="button" class="btn-close btn-close-white me-2 m-auto"
                data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</teleport>

<teleport to="body">
  <!-- Edit Event -->
  <div class="modal fade" id="edit_event_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xxs fw-500" id="exampleModalLabel">{{ event_id ? 'Edit Event' : 'Create your event'}}
          </p>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
        <form @submit.prevent="submitEvent()">
          <div class="modal-body modal-body-scroll">

            <div class="mb-3">
              <label for="event_name" class="form-label text-xxs fw-500">Event Name <span
                  class="text-danger">*</span></label>
              <input type="text" class="form-control rounded text-xxs" id="event_name" placeholder="Enter event name"
                v-model="event_name">
              <p v-if="errors.event_name" class="text-danger text-xxs">{{ errors.event_name }}</p>
            </div>
            <div class="d-flex flex-row justify-content-between mx-1">
            </div>
            <div class="d-flex flex-row justify-content-between mx-1">
              <div v-if="$route.name !== 'home_filter' && !event_id  && portals.length > 0">
                <label for="portals" class="form-label text-xxs fw-500">Tag a portal :
                </label>
                <select class="text-xxs btn-primary fw-500 border-0 rounded btn-sm mb-3 border-end"
                  v-model="selectedPortalId" id="portals">
                  <option value="" selected hidden>
                   Tag a portal
                  </option>
                  <option v-for="portal in portals" :value="portal.id" :key="portal.id">{{ portal.name }}</option>
                </select>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label text-xxs fw-500">Event Type <span class="text-danger">*</span></label>
              <div class="d-flex flex-row align-items-center">
                <div v-for="(type, index) in event_types" :key="index" class="form-check me-3">
                  <input type="radio" class="form-check-input" :value="type" v-model="event_type" :id="`${type}_event`"
                    :name="`event_type`" />
                  <label :for="`${type}_event`" class="form-check-label">{{ type.name }}</label>
                </div>
              </div>
              <p v-if="errors.event_type" class="text-danger text-xxs">{{ errors.event_type }}</p>
            </div>
            <div v-if="!event_id" class="col-md-6 mb-3">
            <label class="form-label text-xxs fw-500">Event Category</label>
            <div class="d-flex flex-row align-items-center gap-3">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio" id="free_event"
                  :value="true"
                  v-model="is_free"
                  checked
                />
                <label class="form-check-label text-xxs" for="free_event">Free</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="paid_event"
                  :value="false" v-model="is_free"

                />
                <label class="form-check-label text-xxs" for="paid_event">Paid</label>
              </div>
            </div>
          </div>
          <div class="mb-3" v-if="is_free && show_rsvp_capacity">
            <label class="form-label text-xxs fw-500">Event Capacity</label>
            <div class="input-group">
              <input
                :disabled="!show_add_extras"
                type="number"
                class="form-control text-xxs"
                v-model.number="event_capacity"
                min="0"
                placeholder="e.g., 100"
              />
              <button
                class="btn btn-outline-none d-flex align-items-center gap-1 px-3"
                type="button"
                @click="toggle_show_capacity_field"
                title="Remove capacity limit"
                :disabled="!show_add_extras"
              >
                <i class="bx bx-x fs-5"></i>
              </button>
            </div>
            <p v-if="errors.event_capacity" class="text-danger text-xxs">{{ errors.event_capacity }}</p>
          </div>

          <button
            v-if="is_free && !show_rsvp_capacity"
            class="btn btn-primary text-xxs rounded text-xxs text-white"
            @click="toggle_show_capacity_field"
          >
            <span>Add event capacity</span>
</button>

          <div v-if="!is_free">
  <label class="form-label text-xxs fw-500">Select Tickets <span class="text-danger">*</span></label>
<div v-for="ticket in allTickets" :key="ticket.id" class="form-check mb-2">
  <input
    type="checkbox"
    :id="'ticket_' + ticket.id"
    :value="ticket.id"
    v-model="selectedTickets"
    class="form-check-input"
    :disabled="assignedTicketIds.includes(ticket.id)"

  />
  <label :for="'ticket_' + ticket.id" class="form-check-label">
    {{ ticket.name }}
    <span v-if="assignedTicketIds.includes(ticket.id)" class="text-muted"></span>
  </label>
</div>

  <!-- Dynamic ticket fields -->
<div
  v-for="ticket in selectedTicketsData"
  :key="'fields_' + ticket.id"
  class="p-3 mb-3 border rounded bg-light"
>
  <h6>{{ ticket.name }}</h6>

  <!-- Price -->
  <div class="mb-3">
    <label class="form-label text-xxs fw-500">Price (R)</label>
    <input
      type="number"
      class="form-control rounded text-xxs"
      v-model.number="ticket.price"
      step="0.01"
      min="0"
      :readonly="ticket.readOnly"
    />
  </div>

  <!-- Quantity -->
  <div class="mb-3">
    <label class="form-label text-xxs fw-500">Quantity</label>
    <input
      type="number"
      class="form-control rounded text-xxs"
      v-model.number="ticket.quantity"
      min="0"
      :readonly="ticket.readOnly"
    />
  </div>

  <!-- Start Date -->
  <div class="mb-3">
    <label class="form-label text-xxs fw-500">Ticket Start Date</label>
    <input
      type="datetime-local"
      class="form-control rounded text-xxs"
      v-model="ticket.start_date"
      :readonly="ticket.readOnly"
    />
    <p v-if="errors[`ticket_${ticket.id}_start_date`]" class="text-danger text-xxs">
  {{ errors[`ticket_${ticket.id}_start_date`] }}
</p>
  </div>

  <!-- End Date -->
  <div class="mb-3">
    <label class="form-label text-xxs fw-500">Ticket End Date</label>
    <input
      type="datetime-local"
      class="form-control rounded text-xxs"
      v-model="ticket.end_date"
      :readonly="ticket.readOnly"
    />
      <p v-if="errors[`ticket_${ticket.id}_end_date`]" class="text-danger text-xxs">
    {{ errors[`ticket_${ticket.id}_end_date`] }}
  </p>
  </div>
</div>
</div>


          <div class="d-flex flex-column ">
            <div v-for="ticket in availableTickets" :key="ticket.id" class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                :id="'ticket_' + ticket.id"
                :value="ticket.id"
                v-model="selectedTickets"
              />
              <label class="form-check-label text-xxs" :for="'ticket_' + ticket.id">
                {{ ticket.name }} - R{{ ticket.price }} ({{ ticket.quantity }} available)
              </label>
            </div>
          </div>




<div class="col-md-6 mb-3">
  <label class="form-label text-xxs fw-500">Is Recurring?</label>
  <div class="d-flex flex-row align-items-center gap-3">
    <div class="form-check">
      <input class="form-check-input" type="radio" id="recurring_yes" :value="true" v-model="is_recurring" />
      <label class="form-check-label text-xxs" for="recurring_yes">Yes</label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" id="recurring_no" :value="false" v-model="is_recurring" />
      <label class="form-check-label text-xxs" for="recurring_no">No</label>
    </div>
  </div>
</div>



<div class="col-md-6 mb-3" v-if="is_recurring">
  <label for="recurring_type" class="form-label text-xxs fw-500">Recurrence Pattern <span
      class="text-danger">*</span></label>
  <select class="form-select rounded text-xxs" id="recurring_type" v-model="recurring_type">
    <option value="" disabled selected>Select recurrence</option>
    <option v-for="pattern in recurring_patterns" :key="pattern.id" :value="pattern.id">
      {{ pattern.name }}
    </option>
  </select>
  <p v-if="errors.recurring_type" class="text-danger text-xxs">{{ errors.recurring_type }}</p>
</div>

            <QuillEditor theme="snow" v-model="event_description" ref="quillEventEditorRef" class="quill-editor"
              placeholder="Enter your description here..." toolbar="full" />
            <div class="row">
              <!-- Event Start Date -->
              <div class="col-md-3 mb-3">
                <label for="start_date" class="form-label text-xxs fw-500">Event Start Date <span
                    class="text-danger">*</span></label>
                <input type="date" class="form-control rounded text-xxs" id="start_date" v-model="start_date" :min="todayDate" :disabled="is_event_dates_locked">
                <p v-if="errors.start_date" class="text-danger text-xxs">{{ errors.start_date }}</p>
              </div>
              <div class="col-md-3 mb-3">
                 <label for="end_time" class="form-label text-xxs fw-500">Start Time <span
                    class="text-danger">*</span></label>
                <input type="time" class="form-control rounded text-xxs" id="start_time" v-model="start_time">

              <p v-if="errors.start_time" class="text-danger text-xxs mt-1">{{ errors.start_time }}</p>
            </div>


              <!-- Event End Date -->
              <div class="col-md-3 mb-3">
                <label for="end_date" class="form-label text-xxs fw-500">Event End Date <span
                    class="text-danger">*</span></label>
                <input type="date" class="form-control rounded text-xxs" id="end_date" v-model="end_date" :min="todayDate" :disabled="is_event_dates_locked">
                <p v-if="errors.end_date" class="text-danger text-xxs">{{ errors.end_date }}</p>
              </div>
              <div class="col-md-3 mb-3">
                <label for="end_time" class="form-label text-xxs fw-500">End Time <span
                    class="text-danger">*</span></label>
                <input type="time" class="form-control rounded text-xxs" id="end_time" v-model="end_time">
                <p v-if="errors.end_time" class="text-danger text-xxs">{{ errors.end_time }}</p>
              </div>

              <!-- RSVP Start Date -->
              <div v-if="is_free"class="col-md-3 mb-3">
                <label for="rsvp_start_date" class="form-label text-xxs fw-500">RSVP Start Date <span
                    class="text-danger">*</span></label>
                <input type="date" class="form-control rounded text-xxs" id="rsvp_start_date"
                  v-model="rsvp_start_date" :min="todayDate">
                <p v-if="errors.rsvp_start_date" class="text-danger text-xxs">{{ errors.rsvp_start_date }}</p>
              </div>
              <div v-if="is_free"class="col-md-3 mb-3">
                <label for="rsvp_start_time" class="form-label text-xxs fw-500">RSVP Start Time <span
                    class="text-danger">*</span></label>
                <input type="time" class="form-control rounded text-xxs" id="rsvp_start_time"
                  v-model="rsvp_start_time">
                <p v-if="errors.rsvp_start_time" class="text-danger text-xxs">{{ errors.rsvp_start_time }}</p>
              </div>

              <!-- RSVP End Date -->
              <div v-if="is_free"class="col-md-3 mb-3">
                <label for="rsvp_end_date" class="form-label text-xxs fw-500">RSVP End Date <span
                    class="text-danger">*</span></label>
                <input type="date" class="form-control rounded text-xxs" id="rsvp_end_date" v-model="rsvp_end_date" :min="todayDate">
                <p v-if="errors.rsvp_end_date" class="text-danger text-xxs">{{ errors.rsvp_end_date }}</p>
              </div>
              <div v-if="is_free"class="col-md-3 mb-3">
                <label for="rsvp_end_time" class="form-label text-xxs fw-500">RSVP End Time <span
                    class="text-danger">*</span></label>
                <input type="time" class="form-control rounded text-xxs" id="rsvp_end_time" v-model="rsvp_end_time">
                <p v-if="errors.rsvp_end_time" class="text-danger text-xxs">{{ errors.rsvp_end_time }}</p>
              </div>
            </div>

            <div class="mb-3">
              <label for="organizer" class="form-label text-xxs fw-500">Organizer <span
                  class="text-danger">*</span></label>
              <input type="text" class="form-control rounded text-xxs" id="organizer"
                placeholder="Enter organizer name" v-model="organizer">
              <p v-if="errors.organizer" class="text-danger text-xxs">{{ errors.organizer }}</p>
            </div>
            <div v-if="event_type.name === 'online' || event_type.name === 'hybrid'" class="mb-4">
              <label for="event_link" class="form-label text-xxs fw-500 d-block">Event Link <span
                  class="text-danger">*</span></label>
              <input id="event_link" type="url" class="form-control rounded text-xxs"
                placeholder="Enter event link (e.g., Zoom, Google Meet,Teams)" v-model="event_link" />
              <p v-if="errors.event_link" class="text-danger text-xxs">{{ errors.event_link }}</p>
            </div>
            <div v-if="event_type.name !== 'online'" :key="event_type.name" class="mb-4">
              <label for="mapSearchBox" class="form-label text-xxs fw-500 d-block">Search for Location</label>
             <input ref="mapInput" id="mapSearchBox" type="text" class="form-control rounded text-xxs"
                placeholder="Search location..." v-model="location" />
              <p v-if="errors.location" class="text-danger text-xxs">{{ errors.location }}</p>
            </div>

            <div class="event-extras"v-if="show_add_extras && is_free">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h3 class="text-xxs fw-500 mb-0">Event Extra</h3>
                <button type="button" class="btn btn-primary btn-sm rounded text-xxs"
                  @click.prevent="addExtra">
                  <i class="bx bx-plus"></i>
                  Add Extra Item
                </button>
              </div>

              <div id="extraItemsList" class="mt-3">
              </div>
            </div>
            <div class="container mt-4"  v-if="showExtrasForm && show_add_extras && extraForms.length > 0">
            <div v-for="(extraForm, extraIndex) in extraForms" :key="extraIndex" id="select_extra_container"
              class="border rounded-3 p-3 mt-3 bg-light">

              <input v-model="extraForm.id" type="text"  class="d-none extra_form_id">

              <div class="mb-3">
                <label class="form-label text-xxs fw-500">Select Extra:</label>
                <input type="text" class="form-control selectExtra" v-model="extraForm.selectedExtra"
                  placeholder="Enter or select extra" :list="'extrasList-' + extraIndex">
                <datalist :id="'extrasList-' + extraIndex">
                  <option v-for="extra in availableExtras" :key="extra.id" :value="extra.name"></option>
                </datalist>
              </div>

              <div v-for="(item, itemIndex) in extraForm.items" :key="itemIndex + '_extra'"
                class="border rounded-3 p-2 mb-2 bg-white">

                <input v-model="item.id" type="text" class="d-none item_id">

                <div class="mb-2">
                  <label class="form-label text-xxs fw-500">Item Name:</label>
                  <input v-model="item.item_name" type="text" class="form-control rounded text-xxs item_name"
                    placeholder="Enter item name">
                </div>


                <div class="mb-2">
                  <label class="form-label text-xxs fw-500">Description:</label>
                  <textarea v-model="item.item_description" type="text" class="form-control rounded-3 text-xxs item_description" rows="2"
                    placeholder="Enter description"></textarea>
                </div>


                <div class="mb-2">
                  <label class="form-label text-xxs fw-500">Price:</label>
                  <input v-model="item.item_price" type="number" class="form-control rounded text-xxs item_price"
                    placeholder="0.00" step="0.01" min="0">
                </div>


                <button @click.prevent="removeExtraItem(extraIndex, itemIndex)" class="btn btn-danger btn-sm">
                  <i class="bx bx-trash"></i>
                </button>
              </div>


              <button @click.prevent="addExtraItem(extraIndex)"
                      class="btn btn-primary btn-sm text-xxs me-2">
                + Add Extra Item
              </button>

            <button @click.prevent="removeExtra(extraIndex)"
                    class="btn btn-danger btn-sm text-xxs">
              Remove Extra
            </button>

            </div>
          </div>
          </div>

          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xxs rounded" :disabled="!is_valid_event">{{ event_id ? 'Update' : 'Save' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="modal fade" id="ticket_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xxs fw-500">{{ selectedEvent?.event_name }}</p>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>

      <!-- BODY -->
      <div class="modal-body">

        <!-- Event Info -->
        <div class="text-start mb-3">
          <p class="mb-1 text-xxs text-muted">
            <i class="bi bi-calendar-event"></i>
            {{ formatDate(selectedEvent?.start_date) }}
          </p>
          <p class="mb-1 text-xxs text-muted" v-if="selectedEvent?.location">
            <i class="bi bi-geo-alt"></i>
            {{ selectedEvent.location }}
          </p>
          <span class="badge bg-light text-xxs rounded text-dark border rounded-pill" v-if="!selectedEvent?.is_free">
            Paid Event
          </span>
        </div>

        <!-- Tickets Section -->
        <!-- Tickets Section -->
        
        <!-- No Tickets -->
        <p class="text-xxs">Select Tickets</p>
        <div v-if="event_tickets.length === 0" class="text-center py-4">
          <p class="text-muted text-xxs">No available tickets for this event.</p>
        </div>

        <!-- Tickets -->
        <div v-else>
          <div v-for="ticket in event_tickets" :key="ticket.id"
              class="d-flex justify-content-between align-items-center border-0 shadow-sm bg-light p-2 mb-2">

            <!-- Ticket Info -->
            <div class="text-start">
              <div class="fw-500">
                {{ ticket?.ticket?.name }}
                <span v-if="ticket.is_sold_out" class="badge bg-danger text-xxs rounded ms-2">Sold Out</span>
              </div>

              <div class="text-success fw-bold">
                R{{ ticket?.price }}
              </div>

              <small class="text-muted" v-if="ticket.available_instances > 0">
                Available: {{ ticket.available_instances- ticket.quantitySelected  }}
              </small>
            </div>

            <!-- Counter -->
            <div v-if="validate_ticket_date(ticket?.start_date)" class="d-inline-flex align-items-center border rounded px-2">
              <button class="btn btn-sm text-xxs rounded border-0 shadow-0 px-2"
                      @click="ticket.quantitySelected = Math.max(0, ticket.quantitySelected - 1)">
                –
              </button>
              <span class="px-3">{{ ticket?.quantitySelected }}</span>
              <button class="btn btn-sm text-xxs rounded border-0 shadow-0 px-2"
                      @click="ticket.quantitySelected = Math.min(ticket.available_instances, ticket.quantitySelected + 1)">
                +
              </button>
            </div>
            <div v-else>
              <span class="badge rounded-pill bg-primary px-3 py-2 fw-light text-uppercase shadow-sm">Coming Soon</span>
            </div>
            
          </div>
        </div>

        <div class="promo-section-modal">
          <!-- Your existing promo code HTML goes here (unchanged) -->
          <div>
            <div class="d-flex align-items-center mb-2">
              <label class="text-muted text-xs mb-0 me-1">Have a promo code?</label>
              <i class="bi bi-question-circle-fill text-muted cursor-pointer text-xxs"></i>
            </div>
 
            <div class="d-flex gap-2">
              <div class="flex-grow-1">
                <input
                  type="text"
                  v-model="promo_input"
                  class="form-control rounded text-xxs"
                  placeholder="Enter promo code"
                  :disabled="is_applying"
                />
              </div>
              <button
                class="btn btn-primary btn-sm text-xxs rounded px-4"
                type="button"
                :disabled="!promo_input || is_applying"
                @click="apply_promo"
              >
                <span v-if="is_applying" class="spinner-border spinner-border-sm me-1"></span>
                Apply code
              </button>
            </div>
 
            <transition name="fade">
              <p v-if="promo_message" :class="['text-xs mt-2 mb-0', promo_status === 'success' ? 'text-success' : 'text-danger']">
                {{ promo_message }}
              </p>
            </transition>
 
            <div class="mt-2 text-end">
              <div v-if="applied_promo" class="text-success text-xxs mb-1">
                <i class="bi bi-tag-fill"></i>
                Applied:
                {{ applied_promo?.promo_code.promo_code_type?.name === 'percentage' ? applied_promo?.promo_code.discount_amount + '%' : 'R' + applied_promo?.promo_code.discount_amount }} off
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <div class="modal-footer d-flex justify-content-between align-items-center border-0">
        <p class="fw-bold text-xxs mb-0">Total: R{{ calculate_total() }}</p>
        <button class="btn btn-primary btn-sm text-xxs rounded px-4" @click="process_to_checkout":disabled="!event_tickets || event_tickets.length === 0"> Proceed To Checkout</button>
      </div>

    </div>
  </div>
</div>

<div class="modal fade" id="event_ticket_modal" tabindex="-1" aria-labelledby="eventticketModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white position-relative">
        <p class="modal-title text-xxs fw-500" id="eventticketModalLabel">{{ ticket_id ? 'Edit Ticket' : 'Create Ticket' }}</p>
        <button
          type="button"
          class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>

      <form @submit.prevent="create_ticket()">
        <div class="modal-body modal-body-scroll">

          <!-- Ticket Name -->
          <div class="mb-3">
            <label for="ticket_name" class="form-label text-xxs fw-500">Ticket Name <span class="text-danger">*</span></label>
            <input type="text" id="ticket_name" class="form-control rounded text-xxs" placeholder="Enter ticket name" v-model="ticket.name">
            <p v-if="errors.name" class="text-danger text-xxs">{{ errors.name }}</p>
          </div>

        </div>

        <div class="modal-footer">
          <button type="submit" class="btn btn-primary text-xxs rounded">{{ ticket_id ? 'Update Ticket' : 'Save Ticket' }}</button>
        </div>
      </form>
    </div>
  </div>
</div>


<div class="modal fade" id="ticketModal" tabindex="-1" aria-labelledby="ticketModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content rounded-4 border-0 shadow-lg">

      <!-- HEADER -->
      <div class="modal-header border-0 pb-0">
        <div>
          <h5 class="modal-title fw-bold" id="ticketModalLabel">
            {{ selectedTicket?.event }}
          </h5>
          <small class="text-muted">Ticket: {{ selectedTicket?.ticket_name }}</small>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- BODY -->
      <div class="modal-body px-4">

        <!-- Ticket & Event Info -->
        <div class="mb-4 p-3 rounded-4 bg-light shadow-sm">
          <div class="row">
            <div class="col-md-6">
              <p class="mb-1 text-muted small">Date Purchased</p>
              <p class="fw-semibold">{{ newFormatDate(selectedTicket?.order_date) }}</p>
            </div>
            <div class="col-md-6">
              <p class="mb-1 text-muted small">Location</p>
              <p class="fw-semibold">{{ selectedTicket?.location || 'Not set' }}</p>
            </div>

            <div class="col-md-6 mt-2">
              <p class="mb-1 text-muted small">Event Starts</p>
              <p class="fw-semibold">{{ newFormatDate(selectedTicket?.start_date) }} </p>
            </div>
            <div class="col-md-6 mt-2">
              <p class="mb-1 text-muted small">Event Ends</p>
              <p class="fw-semibold">{{ newFormatDate(selectedTicket?.end_date) }} </p>
            </div>

            <div class="col-12 mt-3">
              <p class="mb-1 text-muted small">Price</p>
              <h5 class="fw-bold text-success">R{{ selectedTicket?.price }}</h5>
            </div>
          </div>
        </div>

        <!-- Instances / QR Codes -->
        <div v-if="selectedTicket" class="row g-3">
          <div  class="col-6 col-md-4">
            <div class="card p-3 text-center shadow-sm rounded-4">
              <small class="d-block mt-2 text-muted">Ticket ID: {{ selectedTicket.unique_code }}</small>
               <img :src="qr_code(selectedTicket.qr_code)" alt="QR Code">
            </div>
          </div>
        </div>

      </div>

      <!-- FOOTER -->
      <div class="modal-footer border-0 justify-content-center pt-0">
        <small class="text-muted">
          Present this ticket at the event entrance.
        </small>
      </div>

    </div>
  </div>
</div>
</teleport>


